import React from 'react';
import { motion } from 'framer-motion';
import { Bed, Bath, Square, MapPin } from 'lucide-react';
const recentSales = [{
  id: 1,
  image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2950&auto=format&fit=crop',
  address: '11450 Marble Ridge Ct',
  price: 1850000,
  date: 'Sold Mar 2025',
  beds: 4,
  baths: 4.5,
  sqft: 4200,
  community: 'Summerlin'
}, {
  id: 2,
  image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=2906&auto=format&fit=crop',
  address: '28 Vintage Canyon St',
  price: 2100000,
  date: 'Sold Feb 2025',
  beds: 5,
  baths: 5,
  sqft: 5100,
  community: 'Southern Highlands'
}, {
  id: 3,
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2940&auto=format&fit=crop',
  address: '642 Dragon Peak Dr',
  price: 3450000,
  date: 'Sold Feb 2025',
  beds: 5,
  baths: 6,
  sqft: 6800,
  community: 'MacDonald Highlands'
}, {
  id: 4,
  image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?q=80&w=2940&auto=format&fit=crop',
  address: '10245 Spring Mountain Rd',
  price: 875000,
  date: 'Sold Jan 2025',
  beds: 3,
  baths: 2.5,
  sqft: 2400,
  community: 'Spring Valley'
}, {
  id: 5,
  image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?q=80&w=2787&auto=format&fit=crop',
  address: '8830 Coronado Peak Ave',
  price: 1150000,
  date: 'Sold Jan 2025',
  beds: 4,
  baths: 3,
  sqft: 3100,
  community: 'Southwest'
}, {
  id: 6,
  image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?q=80&w=2792&auto=format&fit=crop',
  address: '2240 Green Valley Pkwy',
  price: 925000,
  date: 'Sold Dec 2024',
  beds: 4,
  baths: 3,
  sqft: 2800,
  community: 'Green Valley'
}];
export function RecentActivity() {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(value);
  };
  return <section className="py-24 bg-warmGray px-6" data-id="element-472">
      <div className="max-w-7xl mx-auto" data-id="element-473">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-474">
          <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-475">
            Market Proof
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal" data-id="element-476">
            Recent Market <span className="italic text-gold" data-id="element-477">Activity</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-478">
          {recentSales.map((property, index) => <motion.div key={property.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white border border-warmGray-dark group overflow-hidden hover:shadow-xl transition-shadow duration-300" data-id="element-479">
              <div className="relative h-64 overflow-hidden" data-id="element-480">
                <div className="absolute top-4 left-4 z-10 bg-charcoal text-white text-xs uppercase tracking-wider px-3 py-1 font-medium" data-id="element-481">
                  {property.date}
                </div>
                <img src={property.image} alt={property.address} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-482" />
              </div>

              <div className="p-6" data-id="element-483">
                <div className="flex justify-between items-start mb-4" data-id="element-484">
                  <div data-id="element-485">
                    <h3 className="text-2xl font-serif text-charcoal mb-1" data-id="element-486">
                      {formatCurrency(property.price)}
                    </h3>
                    <p className="text-charcoal-light text-sm" data-id="element-487">
                      {property.address}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-4 text-sm text-charcoal-light mb-6 pb-6 border-b border-warmGray-dark" data-id="element-488">
                  <div className="flex items-center gap-1" data-id="element-489">
                    <Bed className="w-4 h-4 text-gold" data-id="element-490" />
                    <span data-id="element-491">{property.beds}</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-492">
                    <Bath className="w-4 h-4 text-gold" data-id="element-493" />
                    <span data-id="element-494">{property.baths}</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-495">
                    <Square className="w-4 h-4 text-gold" data-id="element-496" />
                    <span data-id="element-497">{property.sqft.toLocaleString()} sqft</span>
                  </div>
                </div>

                <div className="flex items-center gap-2 text-sm uppercase tracking-wider text-charcoal font-medium" data-id="element-498">
                  <MapPin className="w-4 h-4 text-gold" data-id="element-499" />
                  {property.community}
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center mt-16" data-id="element-500">
          <p className="text-charcoal-light font-light mb-6" data-id="element-501">
            See what homes are selling for in your neighborhood.
          </p>
          <a href="#contact" className="inline-block border border-charcoal text-charcoal px-10 py-4 uppercase tracking-widest text-sm hover:bg-charcoal hover:text-white transition-colors duration-300" data-id="element-502">
            Contact Jenny
          </a>
        </motion.div>
      </div>
    </section>;
}